<template>
  <div class="sxChangeItem">
    <Header title="实习异动课程项目类别"></Header>
    <div class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <p>{{ item.kcmc }}[{{ item.kch }}]</p>
        <ul>
          <li>实习项目：{{ item.xmmc }}</li>
          <li>指导老师：{{ item.jsmc }}</li>
          <li class="sxzClass">实习状态：{{ item.sxzt }}</li>
        </ul>
        <span @click="apply(item.sj0609xsid)">申请</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.getsxydsqxmlist({
        xnxq: this.$route.query.xnxq
      });
      this.list = res.data;
    },
    apply(id) {
      this.$router.push({
        path: "/sxChange/apply",
        query: {
          sj0609xsid: id
        }
      });
    }
  }
};
</script>
<style lang="less">
.sxChangeItem .list {
  padding: 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin-bottom: 20px;
    padding: 20px 20px 10px 20px;
    position: relative;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
      margin-bottom: 10px;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 5px;
    }
    .sxzClass {
      color: #f86969;
    }
    .ysxClass {
      color: #12ddd6;
    }

    span {
      width: 70px;
      height: 42px;
      background: #7469f8;
      border-radius: 3px;
      position: absolute;
      top: calc(50% - 10px);
      right: 3%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/sxChange/item.vue